export default __webpack_public_path__ + "static/mcafeeesm-f807430ab75b091ee558f470edda8930.png";